import moment from 'moment';
import React from 'react';
// Refer Your Colleagues
const SeventeenStepTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    registration_link,
    your_name,
    contact_details,
  } = values;

  return (
    <div>
      <p>
        <strong>
          Dear {client_name ? client_name : `[Recipient's Name]`},
        </strong>
      </p>
      <p>
        We’re excited to share a special opportunity for you and your network!
      </p>

      <p>
        As a valued participant of{' '}
        <strong>
          {conference_short_name
            ? conference_short_name
            : `[Conference Short Name]`}
        </strong>
        , you can now <strong>refer your colleagues</strong> and enjoy{' '}
        <strong>mutual benefits</strong>:
      </p>
      <ul>
        <li>
          <strong>Referral Discount</strong>: When you refer a colleague,{' '}
          <strong>both of you</strong> will receive a{' '}
          <strong>10% discount</strong> on the registration fee.
        </li>

        <li>
          <strong>Group Submission Bonus</strong>: Submit{' '}
          <strong>3 or more papers/abstracts together</strong>
          (you or your colleagues), and you’ll be eligible for{' '}
          <strong>a group discount</strong>
          on your registrations
        </li>
      </ul>

      <p>
        To refer someone, simply share this registration link:{' '}
        {registration_link ? (
          <a href={registration_link} target="_blank" rel="noopener noreferrer">
            Click Here
          </a>
        ) : (
          `[Insert registration link]`
        )}
      </p>
      <p>
        Make sure they mention your name during the registration process to
        activate the offer.
      </p>
      <p>
        This is a perfect opportunity to collaborate, save, and contribute
        together to a globally recognized conference. Don’t miss it!
      </p>
      <p>For any queries or support, feel free to reach out.</p>
      <p>
        We look forward to welcoming you and your colleagues at our conference.
      </p>
      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default SeventeenStepTemplate;
